<div class="modal-backdrop" *ngIf="isModalOpen">
  <div class="modal-content">
    <!-- Close button -->
    <button class="close-button" (click)="closeModal()">×</button>

    <!-- Dynamic Title -->
    <h2 class="modal-title">{{ 'modal.title.' + selectedRole | translate }}</h2>

    <!-- Email Address Input -->
    <div class="input-group">
      <label for="email">{{ 'modal.emailLabel' | translate }}</label>
      <input id="email" type="text" [(ngModel)]="emailAddress" (input)="errorMessage=''" />
      <div *ngIf="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
    
    <!-- Error Message -->

    <button [disabled]="isWaiting" 
    (click)="onContinue()" 
                            class="btn btn-primary d-block w-100 btn-text"  
                            type="submit">
                      <div [ngClass]="{'button-content': true}">
                        <div *ngIf="isWaiting" class="spinner-wrapper">
                          <div class="spinnerBtn"></div>
                        </div>
                        <span class="button-text">{{isWaiting ? ('general.pleasewait'|translate): ('modal.continueButton'|translate)}}</span>
                      </div>      
                    </button>

    
  </div>
</div>
